import React from 'react'

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.linkedin.com/in/anjali-a-p-3b571b18a/" className="home__social-icon" target='_blank'>
                <i class="uil uil-linkedin-alt"></i>
            </a>
            <a href="https://github.com/Anjali331997" className="home__social-icon" target='_blank'>
                <i class="uil uil-github-alt"></i>
            </a>
            <a href="mailto:anjaliap3march1997@gmail.com" className="home__social-icon" target='_blank'>
                <i class="uil uil-envelope"></i>
            </a>
        </div>
    )
}

export default Social